import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { IBaseNoteAreaState } from '@src/slide/application/service/note-area-component/core/base/type';

export default class BaseNoteAreaModel<P extends {}> extends BaseViewModel<P> implements IBaseNoteAreaState {
    public noteAreaHeight: number;

    public initModel(props?: P, initObj?: Partial<this>) {
    }
}
